import { Api } from '@automapa/svelte-automapa-template';
import { ImportCreateRequestSchema, ImportResponseSchema, TasksStatusResponseSchema } from '../../shared/ColumnSelectPro/currentImport';
import type { ImportCreateRequestType, TasksStatusResponseType, ImportResponseType } from '../../shared/ColumnSelectPro/currentImport';
import { z } from 'zod';
import { ApiFilterBuilder } from '@automapa/svelte-automapa-template';

export const ImportResolveCoordsResponseSchema = z.object({
    url: z.string(),
    x: z.coerce.number().nullable(),
    y: z.coerce.number().nullable(),
});
export type ImportResolveCoordsResponseType = z.infer<typeof ImportResolveCoordsResponseSchema>;

export const ImportResolveCoordsRequestSchema = z.object({
    urls: z.array(z.string()),
});
export type ImportResolveCoordsRequestType = z.infer<typeof ImportResolveCoordsRequestSchema>;

export class ImportApi {
    public static async create(api: Api, importRequest: ImportCreateRequestType): Promise<ImportResponseType> {
        return api.getData<ImportCreateRequestType, ImportResponseType>(
            'post',
            '/import',
            importRequest,
            ImportCreateRequestSchema,
            ImportResponseSchema
        );
    }

    public static async getOne(api: Api, id: number): Promise<ImportResponseType> {
        // return new Promise<ImportResponseType>((resolve, reject) => {
        //     resolve(uploadResponse)
        // });
        // FIXME: This is a mock response, replace with real API call
        return api.getData<undefined, ImportResponseType>('get', `/import/${id}`, undefined, z.undefined(), ImportResponseSchema);
    }

    public static async getStatus(api: Api, id: number): Promise<TasksStatusResponseType> {
        return api.getData<any, TasksStatusResponseType>(
            'post',
            `/import/${id}/check_confirm_progress`,
            {},
            z.object({}),
            TasksStatusResponseSchema
        );
    }

    public static async getAll(api: Api, filter: ApiFilterBuilder): Promise<ImportResponseType[]> {
        return api.getData<undefined, ImportResponseType[]>(
            'get',
            '/imports' + filter.getUri(),
            undefined,
            z.undefined(),
            z.array(ImportResponseSchema)
        );
    }

    public static async remove(api: Api, id: number): Promise<void> {
        return api.delete(`/import/${id}`);
    }

    public static async resolveCoords(api: Api, shortUrls: string[]): Promise<ImportResolveCoordsResponseType[]> {
        return api.getData<ImportResolveCoordsRequestType, ImportResolveCoordsResponseType[]>(
            'post',
            '/import/resolve_coords',
            { urls: shortUrls },
            ImportResolveCoordsRequestSchema,
            z.array(ImportResolveCoordsResponseSchema)
        );
    }
}
